// based on https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/
function isLocalStorageSupported() {
  try {
    if (!window?.localStorage) {
      return false;
    }

    const testKey = '------magine-random-test-key';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);

    return true;
  } catch (e) {
    return false;
  }
}

class Storage {
  _isLocalStorageSupported = isLocalStorageSupported();
  _inMemStorage = {};

  getItem(key) {
    if (this._isLocalStorageSupported) {
      return localStorage.getItem(key);
    }

    return this._inMemStorage[key];
  }

  setItem(key, value) {
    if (this._isLocalStorageSupported) {
      localStorage.setItem(key, value);
    } else {
      this._inMemStorage[key] = String(value);
    }
  }

  removeItem(key) {
    if (this._isLocalStorageSupported) {
      localStorage.removeItem(key);
    } else {
      delete this._inMemStorage[key];
    }
  }
}

export default new Storage();
